<template>
  <section class="icon-keyboard">
    <div class="icon-keyboard__navigation">
      <div class="radio icon-keyboard__navigation--radio">
        <div
          v-for="(colour, i) in colours"
          :key="`colour_${i}`"
          :class="colour"
          class="radio__indicator"
          @click="chosenBackground = colour"
        >
          <div
            :class="`${
              chosenBackground === 'charcoal' ||
              chosenBackground === 'aubergine'
                ? 'white'
                : 'charcoal'
            }`"
            class="radio__indicator--chosen"
            v-if="chosenBackground === colour"
          ></div>
        </div>
      </div>
      <a
        class="icon-keyboard__navigation--button button"
        href="https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/jet-icons.zip"
        target="_blank"
        download
        >Download set</a
      >
    </div>
    <div class="icon-keyboard__main">
      <img
        class="icon-keyboard__main--arrow icon"
        src="../assets/images/arrow-left.svg"
        @click="page > 1 && (page -= 1)"
      />
      <div class="icon-keyboard__main--grid">
        <div
          class="icon"
          v-for="(icon, i) in getIconBatch"
          :key="`icon_${i}`"
          :class="chosenBackground"
        >
          <a
            target="_blank"
            :href="`https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/${getPathColour}/${icon}${getOutlineColour}.svg`"
            download
          >
            <img
              :src="require(`../assets/images/${icon}${getOutlineColour}.svg`)"
            />
          </a>
        </div>
      </div>

      <img
        class="icon-keyboard__main--arrow"
        src="../assets/images/arrow-right.svg"
        @click="page < 7 && (page += 1)"
      />
    </div>
    <div class="icon-keyboard__footer">
      <h4>{{ page }} / 7</h4>
    </div>
  </section>
</template>

<script>
export default {
  name: 'IconKeyboard',
  data() {
    return {
      chosenBackground: 'mozzarella',
      page: 1,
    }
  },
  props: {
    icons: {
      type: Array,
      default: () => [],
      required: true,
    },
    colours: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    getOutlineColour() {
      return this.chosenBackground === 'mozzarella' ||
        this.chosenBackground === 'cupcake' ||
        this.chosenBackground === 'berry' ||
        this.chosenBackground === 'turmeric'
        ? ' - charcoal'
        : ' - white'
    },
    getPathColour() {
      return this.chosenBackground === 'mozzarella' ||
        this.chosenBackground === 'cupcake'
        ? 'Charcoal'
        : 'White'
    },
    getIconBatch() {
      if (this.page === 1) return this.icons.slice(0, 32)
      if (this.page === 2) return this.icons.slice(32, 64)
      if (this.page === 3) return this.icons.slice(64, 96)
      if (this.page === 4) return this.icons.slice(96, 128)
      if (this.page === 5) return this.icons.slice(128, 160)
      if (this.page === 6) return this.icons.slice(160, 192)
      return this.icons.slice(192, this.icons.length)
    },
  },
  methods: {
    async downloadImage(path) {
      const a = document.createElement('a')
      a.href = await this.toDataURL(path)
      a.download = 'myImage.svg'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    toDataURL(url) {
      return fetch(url)
        .then((response) => {
          return response.blob()
        })
        .then((blob) => {
          return URL.createObjectURL(blob)
        })
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.icon-keyboard {
  width: 100%;
  position: relative;
  &__navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--radio {
      width: 200px;
      margin: 0 20px 0 0;
      @media (max-width: $tablet) {
        margin: 0 0 20px;
      }
    }
    &--button {
      background-color: var(--color-charcoal-1);
      color: var(--color-white-1);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      img {
        width: 15px;
      }
    }
  }
  &__main {
    display: flex;
    margin: 50px 0;
    &--arrow {
      width: 5%;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &--grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      .icon {
        width: 10%;
        margin: 1%;
        border-radius: 30px;
        cursor: pointer;
        img {
          width: 70%;
          padding: 15%;
        }
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
  &__footer {
    text-align: center;
  }
}
</style>